import { inject } from '@angular/core';
import { ProjectSetupCreateRequest } from '@app/models/project.models';
import { ProjectSetupService } from '@app/services/project-setup/project-setup.service';
import { signalStore, withHooks, withMethods } from '@ngrx/signals';

export const ProjectSetupStore = signalStore(
  { providedIn: 'root' },
  withMethods((store) => {
    const projectSetupService = inject(ProjectSetupService);
    const createProjectIdea = (projectIdea: ProjectSetupCreateRequest) =>
      projectSetupService.createProjectIdea(projectIdea);
    const updateProjectIdea = (
      projectId: string,
      projectIdea: ProjectSetupCreateRequest
    ) => projectSetupService.updateProjectIdea(projectId, projectIdea);
    const getProjectIdea = (projectId: string) =>
      projectSetupService.getProjectIdea(projectId);
    return {
      createProjectIdea,
      updateProjectIdea,
      getProjectIdea,
    };
  }),
  withHooks((store) => {
    return {
      onInit() {
        //
      },
    };
  })
);
